(function() {
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  define('NowPlaying',['marionette'], function(Marionette) {
    var NowPlaying;
    return NowPlaying = (function(_super) {
      __extends(NowPlaying, _super);

      NowPlaying.prototype.api = 'http://entertainment.eusa.ed.ac.uk/db';

      function NowPlaying() {
        this.navigate = __bind(this.navigate, this);
        NowPlaying.__super__.constructor.apply(this, arguments);
        this.addRegions({
          mainRegion: '[data-main-content]'
        });
        require(['jquery', 'handlebars', 'app/extensions/ajaxFormatAdder', 'app/router/router']);
      }

      NowPlaying.prototype.navigate = function(url, options) {
        return this.router.navigate(url, options);
      };

      return NowPlaying;

    })(Marionette.Application);
  });

}).call(this);

//# sourceMappingURL=NowPlaying.js.map
;
